/**
 * Âncora de item de sanfona.
 *
 * O item da sanfona (`agsusAccordion`) é um <details>; a `ancora` dele vira o
 * `id`. Quem quer levar o leitor até um item (o `#` do endereço, a barra de
 * âncoras) precisa abri-lo antes de rolar até ele, e abrir também os itens de
 * fora quando a sanfona está dentro de outra.
 */

// Evento no `window` com que a barra de âncoras avisa a sanfona. Leva
// `detail: { id }` (a âncora, sem `#`). O clique da barra faz `preventDefault` +
// `history.replaceState`, o que não dispara `hashchange`.
export const EVENTO_ANCORA = 'agsus:ancora';

/** Âncora como o `id` do <details> a aceita: sem `#` e sem espaços. */
export const limparAncora = (valor) =>
  String(valor ?? '').replace(/[#\s]/g, '');

/**
 * Abre o `<details id=id>` e todo `<details>` que o contém.
 *
 * @param {string} id  a âncora, sem `#`.
 * @param {Document} [root]  documento onde procurar (padrão: `document`).
 * @returns {HTMLElement|null} o <details> achado, ou `null` se não há um
 *   <details> com esse id (outro tipo de elemento não conta).
 */
export const abrirPorAncora = (id, root) => {
  const doc = root || (typeof document !== 'undefined' ? document : null);
  if (!id || !doc) return null;
  const alvo = doc.getElementById(id);
  if (!alvo || alvo.tagName !== 'DETAILS') return null;
  for (let d = alvo; d; d = d.parentElement?.closest('details')) {
    d.open = true;
  }
  return alvo;
};

export default abrirPorAncora;
